var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { PlatformType, getPlatformType } from '@nibfe/mkt-env-api';
import msi from "./msi/index.web"; // NOTE: KNB不再进行迭代，所以采用msi
const isMRN = false;
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import { useState } from "@max/max";
const platform = getPlatformType();
const isDp = [PlatformType.dpApp, PlatformType.dpAppWebView].includes(platform);
const CALENDAR_SCENE_TOKEN = 'dd-2feed6b01d76054a'; // NOTE:日历需要申请日历写权限
export const useActivitySubscription = () => {
    const ctx = useMonitorEngineContext();
    const [isSubscribed, setIsSubscribed] = useState(false);
    const handleMsiSubscribe = (params) => {
        var _a;
        const { eventUrl, eventContent, eventTitle, dateTime } = params;
        const startTime = dateTime / 1000;
        const endTime = startTime + 3600;
        const subscribeParams = {
            _mt: {
                sceneToken: CALENDAR_SCENE_TOKEN
            },
            title: eventTitle || '领券活动提醒',
            description: eventContent || '',
            url: eventUrl || '',
            startTime,
            endTime,
            alarm: false,
            alarmOffset: 0,
            switchToCalendar: false,
            // 是否调用系统日历，false，表示直接添加日历
            success: () => {
                setIsSubscribed(true);
                ctx._uiInteractionAPI.toast.show({
                    content: '预约成功，已添加到日历提醒'
                });
            },
            fail: (e) => {
                if (isDp) {
                    ctx._uiInteractionAPI.toast.show({
                        content: '添加日历提醒失败，请确认已打开日历权限'
                    });
                }
                else {
                    ctx._uiInteractionAPI.toast.show({
                        content: '添加日历提醒失败，请确认已打开日历权限'
                    });
                }
                ctx._raptorReport.monitorReportLog('[MCP-USE]-calendarOpenError', {
                    secCategory: '[MCP-USE]-calendarOpenError',
                    level: 'info',
                    error: e,
                    tags: {
                        sceneToken: CALENDAR_SCENE_TOKEN
                    }
                });
            }
        };
        (_a = msi === null || msi === void 0 ? void 0 : msi.addPhoneCalendar) === null || _a === void 0 ? void 0 : _a.call(msi, subscribeParams);
    };
    const onSubscribe = (params) => __awaiter(void 0, void 0, void 0, function* () {
        if (isMRN) {
            if (params.dateTime) {
                handleMsiSubscribe(Object.assign(Object.assign({}, params), { dateTime: params === null || params === void 0 ? void 0 : params.dateTime }));
            }
            else {
                ctx._raptorReport.monitorReportLog('[MCP-USE]-calendarStartTimeError', {
                    secCategory: '[MCP-USE]-calendarStartTimeError',
                    level: 'info',
                    content: '预约日历提醒，开始日期错误',
                    tags: {
                        sceneToken: CALENDAR_SCENE_TOKEN
                    }
                });
            }
        }
        else {
            ctx._uiInteractionAPI.toast.show({
                content: '预约成功'
            });
            setIsSubscribed(true);
        }
    });
    return {
        onSubscribe,
        isSubscribed
    };
};
